import styled from "styled-components";

export const ConfirmationWrapperStyled = styled.div`
	width: ${(props) => (props.desktop ? "90%" : "100%")};
	display: ${(props) => (props.desktop ? "flex" : "block")};
	margin-top: ${(props) => (props.desktop ? "40px" : "0")};
	flex-direction: column;
	align-items: ${(props) =>
		props.isLoggedIn
			? props.fieldsExist
				? "flex-end"
				: "flex-start"
			: "flex-end"};
	h5 {
		font-weight: 500;
	}
	.ant-alert,
	.ant-alert-info {
		border: none;
		background-color: transparent;
	}
`;
